import _isNil from 'lodash/isNil';

export function getAutocompleteEquality(
    option,
    value: string,
    placeholder = ''
) {
    return option.label === value || value === placeholder || _isNil(value);
}
